import { useContext } from 'react';
import ProjectsContext from '../ProjectsContext';

const useProjectsContext = () => useContext(ProjectsContext)

export default useProjectsContext
